import React, { useRef, useState, useEffect } from "react";
import { getDateTime } from "app/common/LocalFunction";
import {
  APPOINTMENT_STAGES,
  TYPE_CUSTOMER_JOURNEY,
} from "app/common/LocalConst";
import { IconButton, Tooltip } from "@material-ui/core";
import IconPen from "app/common/Icon/IconPen";
import { useStore } from "app/stores";

const CustomerJourneySeriesTimeline = ({ items }) => {
  return (
    <div className="timeline-group mt-2">
      <ol className="timeline">
        {items?.length > 0 &&
          items.map((item, index) => (
            <li className="timeline-item" key={index}>
              <div className="timeline-content">
                <div style={{ fontWeight: 600 }}>
                  🕒 {getDateTime(item?.seriesTime)}
                </div>
                {item?.personName && (
                  <div style={{ color: "#2563eb", fontWeight: 600 }}>
                    👤 {item?.personName}
                  </div>
                )}
                <div style={{ fontSize: 12 }}>
                  <em>{item?.title}</em>:&nbsp;
                  <strong style={{ color: "crimson" }}>{item?.subTitle}</strong>
                  &nbsp;
                  <span style={{ color: "green", fontWeight: 600 }}>
                    {TYPE_CUSTOMER_JOURNEY?.find(
                      (el) => el.value === item?.seriesType
                    )?.name || ""}
                  </span>
                </div>
              </div>
            </li>
          ))}
      </ol>
    </div>
  );
};

export default CustomerJourneySeriesTimeline;
